import { CollectedData } from 'src/interfaces/collectedData'
import {
  CollectedDataApprovalType,
  CollectedDataStepType,
  DocumentUploadOrigin,
} from 'src/constants/collectedData'

const CUSTOMER_APPROVAL_TYPES = [
  CollectedDataApprovalType.CustomerApproval,
  CollectedDataApprovalType.InternalThenCustomerApproval,
  CollectedDataApprovalType.CustomerThenInternalApproval,
]

const isCustomerApprovalStep = (collectedData: CollectedData): boolean => {
  const { approvalType } = collectedData.collectDataStep

  return !!approvalType && CUSTOMER_APPROVAL_TYPES.includes(approvalType)
}

export function isExpirationRequiredOnApprove(collectedData: CollectedData): boolean {
  return (
    collectedData.collectDataStep.type === CollectedDataStepType.LmsTraining &&
    collectedData.documents.some((document) => {
      return document.uploadOrigin === DocumentUploadOrigin.ManualContractorUpload
    })
  )
}

/**
 * Whether the user can set effective and expiration dates when approving this step.
 * True when it's a combined step with CustomerApproval or InternalThenCustomerApproval.
 */
export function canSetDatesOnApprove(
  collectedData: CollectedData,
  isCombinedStep: boolean,
): boolean {
  return (
    (isCombinedStep && isCustomerApprovalStep(collectedData)) ||
    isExpirationRequiredOnApprove(collectedData)
  )
}
